<div class="header">
  <h3>{{'TAX-REPORT.TITLE' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearData()"></app-filter-header>

  <div class="row row-eq-height">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown class="dv-dropdown"
                    selectId="customercode"
                    [options]="customercode"
                    [(ngModel)]="selectedCustomercode"
                    (onChange)="filterDeliverycodeList()"
                    [autoDisplayFirst]="false"
                    placeholder="{{'FILTER.CUSTOMER-CODE' | translate}}"
                    [style]="{'z-index': 3}"
                    filter="true"
        >

        </p-dropdown>
        <label for="customercode">{{'FILTER.CUSTOMER-CODE' | translate}}</label>
      </div>

      <div class="dropdown-label-group m-t-10 d-none">
        <p-dropdown class="dv-dropdown" selectId="companyBusiness" [options]="homeproGroup"
                    [(ngModel)]="selectedHomeproGroup" [autoDisplayFirst]="false"
                    placeholder="{{'FILTER.BUSINESS-TYPE' | translate}}">
        </p-dropdown>
        <label for="companyBusiness">{{'FILTER.BUSINESS-TYPE' | translate}}</label>
      </div>

      <div class="dropdown m-t-10" #dd="ngbDropdown" ngbDropdown autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange" ngbDropdownToggle
                 placeholder="{{'FILTER.DATE' | translate}}" readonly>
          <label for="calendarDropdown">{{'FILTER.DATE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="customercodeDeliverycode"
          [options]="deliverycodeList"
          [(ngModel)]="selectedDeliverycode"
          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.DELIVERY-CODE' | translate}}"
          [style]="{'z-index': 4}"
          filter="true">
        </p-dropdown>
        <label for="customercodeDeliverycode">{{'FILTER.DELIVERY-CODE' | translate}}</label>
      </div>

      <div class="dropdown-label-group m-t-10">
        <p-multiSelect
          class="dv-dropdown"
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [panelStyle]="{minWidth: '337px'}"
          [defaultLabel]="defaultLabel"
          [maxSelectedLabels]="1"
        >
        </p-multiSelect>
        <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
      </div>
      <div class="d-none">
        <p-autoComplete [(ngModel)]="deliverycode" [disabled]="allDeliverycode" field="full_name" [multiple]="true"
                        [suggestions]="deliverycodeSuggest" [size]="30" (completeMethod)="searchDeliverycode($event)"
                        (onClear)="clearDeliverycode()" class="dv-autocomplete" placeholder="{{'FILTER.DELIVERY-CODE' | translate}}">
        </p-autoComplete>
      </div>

      <div class="m-t-10 d-none">
        <p-autoComplete
          [(ngModel)]="documentType" [disabled]="allDocType" field="type" [multiple]="true"
          [suggestions]="typeSuggest"
          [size]="30" (completeMethod)="searchDocumentType($event)"
          (onClear)="clearDocType()" class="dv-autocomplete"
          placeholder="{{'FILTER.DOCUMENT-TYPE' | translate}}">
        </p-autoComplete>
      </div>
    </div>

  </div>

  <div class="row" *ngIf="errorMsg">
    <div class="col text-center text-red">
      {{ errorMsg }}
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination [(currentPage)]="currentPage"
                         [(itemsPerPage)]="itemsPerPage"
                         [totalItems]="totalItems"
                         (pageChange)="pageChanged()"
                         (optionChange)="searchButtonClicked()"
                         *ngIf="no_data === false && totalItems !==0"
  >
    <button type="button" class="btn btn-dv"(click)="downloadAll()">
            {{'COMMON.EXCELALL' | translate}}
    </button>

    <button type="button" class="btn btn-dv btn-wide"[disabled]="!EnabledDownloadSelected()"
            (click)="downloadMerge()">{{'COMMON.MERGE' | translate}}
    </button>


  </app-custom-pagination>

  <!--<div class="row m-t-20" *ngIf="loading === true">-->
  <!--<div class="col-12 text-center">-->
  <!--<i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>-->
  <!--</div>-->
  <!--</div>-->

  <div class="row m-t-20" *ngIf="no_data === true && loading === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>

    </div>
  </div>

  <div class="m-t-20 text-center ">
    <p-table #tt  tableStyleClass="table" *ngIf="no_data === false" [loading]="loading"
             [columns]="tableCol" [value]="tableData" [customSort]="true" (onSort)="sort($event)" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="pageChanged()">
            {{col.header}}
            <!--<p-sortIcon [field]="col.field"></p-sortIcon>-->
          </th>
          <!--          <th>{{'TAX-REPORT.CORRECT' | translate}}</th>-->
          <th>{{'COMMON.DOWNLOAD' | translate}}</th>
          <th scope="col">
            <p-checkbox class="dv-checkbox"binary="true" (onChange)="selectDeselectAll($event)" [ngModel]="checkAll"></p-checkbox>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.customer_code}}</td>
          <td>{{data.delivery_code}}</td>
          <td>{{data.header_issue_display}}</td>
          <td class="d-none">{{data.group__name}}</td>
          <td>{{data.corporate_branch__name}}</td>
          <td>{{data.rd_document_type_display}}</td>
          <td class="d-none">{{data.document_type__type}}</td>
          <td>{{data.start_end_document}}</td>
          <td>{{data.total_documents}}</td>
          <!--<td>{{data.last_day_document_display}}</td>-->
          <td>
            <span>
              {{data.total_missing_documents.toLocaleString()}}
            </span>
            <!--Excel delete ngIf in i -->
            <span>
              <button *ngIf="data.total_missing_documents !== 0" style="width: 100%"
                      class="btn btn-dv btn-clean btn-compact" (click)="downloadMissingDocs(data, index)">
                <i *ngIf="data.loading_missing_docs_excel === true" class="fa fa-spinner fa-spin m-r-5"></i>
                Excel
              </button>

            </span>
          </td>
          <td>
            {{data.total_non_vat.toLocaleString()}}
          </td>
          <td>
            {{data.total_vat.toLocaleString()}}
          </td>
          <td>
            {{data.total_payment.toLocaleString()}}
          </td>
          <!--<td>-->
          <!--{{(data.total_non_vat + data.total_basis_amount + data.total_vat).toLocaleString()}}-->
          <!--</td>-->
          <!--          <td class="text-center">-->
          <!--            <i *ngIf="!canUserApproveDoc() && data.approved === true" class="fa fa-check m-r-5">-->
          <!--            </i>-->
          <!--            <input *ngIf="canUserApproveDoc()"-->
          <!--            type="checkbox"-->
          <!--            [(ngModel)]="data.approved"-->
          <!--            (change)="confirmDocument($event, content, index, data)">-->
          <!--            <p-checkbox class="dv-checkbox" *ngIf="canUserApproveDoc()" [(ngModel)]="data.approved" binary="true"-->
          <!--                        (click)="confirmDocument($event, content, index)" [inputId]="'chkbox' + index"></p-checkbox>-->
          <!--          </td>-->
          <td>
            <button class="btn btn-dv btn-clean btn-compact" style="width: 100%" (click)="getExportDocs(data, index)">
              <i *ngIf="data.loading_all_docs_excel === true" class="fa fa-spinner fa-spin m-r-5"></i>Excel
            </button>

          </td>
          <td style="text-align: center">
            <p-checkbox (onChange)="downloadCheckbox(data,index,$event)" class="dv-checkbox" binary="true" [(ngModel)]="selectedValues[index]"></p-checkbox>
          </td>

        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <!--<h4 class="modal-title" id="modal-basic-title">Alert</h4>-->
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <h5>{{'COMMON.CONFIRM-TRANSACTION' | translate}}</h5>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide"
              (click)="revertBack()">{{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" [disabled]="cofirm_loading" (click)="confirm()">
        <i *ngIf="cofirm_loading" class="fa fa-spinner fa-spin m-r-5"></i>
        {{'COMMON.OK' | translate}}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #loadingModal let-c="close" let-d="dismiss"></ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report.component.html